// extracted by mini-css-extract-plugin
export default {"container":"CustomSlider_container__CyDXj","header":"CustomSlider_header__UUk1i","dotsContainer":"CustomSlider_dotsContainer__gLtap","customDots":"CustomSlider_customDots__tP5v4"};